export const SLACK_ALERT_TRIGGER = {
  newResults: 'new_results',
  newOrChangedResults: 'new_and_changed_results',
  always: 'always',
} as const;

export const TRIGGER_TO_TEXT: Record<TSlackAlertType, string> = {
  new_results: 'every new row',
  new_and_changed_results: 'every new or changed row',
  always: 'every row (changed or otherwise)',
} as const;

export type TSlackAlertType =
  typeof SLACK_ALERT_TRIGGER[keyof typeof SLACK_ALERT_TRIGGER];

export const SLACK_ALERT_FREQUENCY = {
  daily: 'daily',
  hourly: 'hourly',
  mins10: 'mins10',
} as const;

export const FREQUENCY_TO_TEXT: Record<TAlertFrequency, string> = {
  daily: 'Daily',
  hourly: 'Whenever results change (every hour)',
  mins10: 'Whenever results change (every 10 minutes)',
} as const;

export type TAlertFrequency = keyof typeof SLACK_ALERT_FREQUENCY;
